module.exports = __webpack_public_path__ + "fonts/fontello.b599a15.eot";